<template>
    <div :id="rootId" class="calendar-list">
        <template v-if="calendarEvents?.length > 0">
            <div v-for="(calendarEvent, i) in calendarEvents" class="calendar-list-event">
                <span class="h3">
                    {{ calendarEvent.Name }}
                    <span v-if="calendarEvent.Cancelled" class="badge badge-danger">CANCELED</span>
                </span>
                <p>
                    {{ dayjs(calendarEvent.StartDate).format('M/D/YYYY') }}, {{ dayjs(calendarEvent.StartDate).format('h:mm A') }}
                    <template v-if="calendarEvent.EndDate">
                        - {{ dayjs(calendarEvent.EndDate).format('h:mm A') }}
                    </template>
                </p>

                <div class="event-description" v-html="calendarEvent.Description"></div>

                <p v-if="calendarEvent.LocationName"><b>Location</b>: <br /> {{ calendarEvent.LocationName }}</p>
                <p v-if="calendarEvent.ContactName">
                    <b>Contact</b>: <br />
                    <a v-if="calendarEvent.ContactEmail?.trim()" :href="`mailto:${calendarEvent.ContactEmail.trim()}`">{{ calendarEvent.ContactName }}</a>
                    <template v-else>
                        {{ calendarEvent.ContactName }}
                    </template>
                    <template v-if="calendarEvent.ContactPhone?.trim()">
                        &nbsp;-&nbsp;
                        <a :href="`tel:${calendarEvent.ContactPhone.replace('.', '')}`">{{ calendarEvent.ContactPhone.trim() }}</a>
                    </template>
                </p>
                <p v-if="calendarEvent.Url"><b>Url</b>: <br /> <a :href="calendarEvent.Url" target="_blank">{{ calendarEvent.Url }}</a></p>

                <br />

                <div v-if="atcHtml" v-html="atcHtml[i]"></div>
                <hr />
            </div>
        </template>

        <div v-else class="text-center">No upcoming events.</div>

    </div>
</template>

<script setup>
    import { ref, computed, onMounted, watch, nextTick } from 'vue';
    import '../../../../css/components/port-calendar.less';
    import dayjs from 'dayjs';
    import { AddToCalendar } from "../../port-addtocalendar";
    import { convertCalendarEvent } from "./calendar-utilities";

    const props = defineProps({
        widgetId: {
            type: String,
            required: true
        },
        calendarName: {
            type: String
        },
        initialEvents: {
            type: Array
        },
        jsonUrl: {
            type: String
        },
        shownEvents: {
            type: Number,
            default: 3
        },
        eventId: {
            type: Number
        }
    });

    const calendarEvents = ref();

    const rootId = computed(() => `calendar-list-${props.widgetId}`);

    const atcHtml = computed(() => {
        const convertedEvents = _.map(calendarEvents.value, event => convertCalendarEvent(event));
        const atc = new AddToCalendar({
            events: convertedEvents,
            identifier: rootId.value
        });
        return _.map(convertedEvents, event => atc.render(event));
    });

    function loadEvents(eventId) {
        // TODO: if eventId is specified, set calendarEvents to single one
        fetch(`${props.jsonUrl}?calendarName=${encodeURIComponent(props.calendarName)}`)
            .then(response => response.json())
            .then(data => {
                if (eventId) {
                    const specified = _.find(data.Events, e => e.Id === eventId);
                    calendarEvents.value = [specified];
                } else {
                    calendarEvents.value = _(data.Events)
                        .filter(e => dayjs(e.StartDate).isAfter(dayjs()))
                        .sortBy(e => e.StartDate)
                        .take(props.shownEvents)
                        .value();
                }
            });
    }

    onMounted(() => {
        if (props.initialEvents) {
            calendarEvents.value = props.initialEvents;
        } else if (props.jsonUrl) {
            loadEvents(props.eventId);
        }
    });

    watch(() => props.calendarName, () => {
        if (props.jsonUrl) {
            loadEvents();
        }
    });
</script>

<style>
    .calendar-list {
        /*max-width: 800px;*/
        width: 100%;
        margin: 0 auto;
        padding-bottom: 25px;
    }

    .calendar-list-event h3 {
        margin-bottom: 0;
    }
</style>